import moment from "moment";

export const searchBy = {
    filterType: "Sort By",
    inputName: "search_by",
    options: [
      {
        name: "Descending ",
        code: "desc",
      },
      {
        name: "Ascending",
        code: "asc",
      },
    ],
  };

  
export const columns = [
    
   
    {
      field: "name",
      header: "Unit Name",
      accessor: (row) => (
        <>
          <div className="">
            <p>{row?.name}</p>
          </div>
        </>
      ),
    },
    {
      field: "unit",
      header: "unit",
      accessor: (row) => (
        <>
          <div className="">{row?.unit}</div>
        </>
      ),
    },
  ];